import React from 'react';
import clsx from 'clsx';
import { Link } from '@/components/reusable/link';
import { motion } from 'motion/react';
import { INTRO } from '@/components/reusable/animations';

export function Text({ className, ...props }) {
  return (
    <p
      data-slot="text"
      {...props}
      className={clsx(className, 'text-pretty')}
    />
  )
}

export function Intro({ className, animate = true, ...props }) {
  const Component = animate ? motion.div : 'div';

  return (
    <Component
      data-slot="text"
      {...props}
      {...(animate ? INTRO : {})}
      className={clsx(className, 'text-pretty')}
    />
  )
}

export function TextLink({ className, ...props }) {
  return (
    <Link
      {...props}
      className={clsx(
        className,
        'text-black font-bold underline decoration-black hover:no-underline data-[hover]:decoration-none dark:text-white dark:decoration-white/50 dark:data-hover:decoration-white'
      )}
    />
  )
}